import { Typography, TypographyProps, ButtonProps } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { CSSObject, styled } from '@mui/system';

interface StepTypographyProps extends TypographyProps {
  visited?: boolean;
  completed?: boolean;
  active?: boolean;
  disabled?: boolean;
}

export const StepTypography = styled(Typography, {
  shouldForwardProp: (props) => {
    if (props === 'active') {
      return false;
    }

    if (props === 'completed') {
      return false;
    }

    if (props === 'visited') {
      return false;
    }

    if (props === 'disabled') {
      return false;
    }

    return true;
  },
})<StepTypographyProps>((props) => {
  const style: CSSObject = {
    color: props.theme.palette.cdmBrandThird.main,
    fontSize: 'inherit',
    fontWeight: 400,
  };

  if (props.active) {
    style.color = props.theme.palette.cdmBrandThird.contrastText;
    // style.fontWeight = 700;
  }

  if (props.active && props.completed) {
    // style.fontWeight = 700;
  }

  if (props.disabled) {
    style.color = 'inherit';
  }

  return style;
});

interface StepButtonProps extends ButtonProps {
  visited?: boolean;
  completed?: boolean;
  active?: boolean;
  disabled?: boolean;
  isButton?: boolean;
  backgroundColorActive?: string;
}

export const StepButton = styled(PmiButton, {
  shouldForwardProp: (props) => {
    if (props === 'active') {
      return false;
    }

    if (props === 'completed') {
      return false;
    }

    if (props === 'visited') {
      return false;
    }

    if (props === 'isButton') {
      return false;
    }

    return true;
  },
})<StepButtonProps>((props) => {
  const style: CSSObject = {
    // color: props.theme.palette.primary.main,
    backgroundColor: 'transparent',
    pointerEvents: 'auto',
    // fontSize: 'inherit',
    // fontWeight: 400,
  };

  if (props.active && !props.disabled) {
    style.backgroundColor = props.backgroundColorActive || props.theme.palette.cdmBrandThird.main;
    style.color = props.theme.palette.cdmBrandThird.contrastText;
    style.pointerEvents = 'none';
    // style.fontWeight = 700;
  }

  if (props.isButton) {
    style['&:hover'] = {
      backgroundColor: 'transparent !important',
      color: props.theme.palette.cdmBrandThird.main,
    };

    style.pointerEvents = 'auto';
  }

  if (props.active && props.completed) {
    // style.fontWeight = 700;
  }

  return style;
});
